import React from 'react';

import AKSearchIcon from '@atlaskit/icon/core/search';
import { token } from '@atlaskit/tokens';

interface Props {
	isExpanded: boolean;
	/**
	 * @default 'small'
	 */
	primaryColor?: string;
	defaultColor?: string;
	label?: string;
}

export const LegacySearchIcon = ({
	isExpanded,
	primaryColor = token('color.text'),
	defaultColor = token('color.text.subtlest'),
	label = '',
}: Props): React.JSX.Element => (
	<AKSearchIcon
		label={label}
		// NOTE: color do not accept string type but here primaryColor is string, so need to use any
		color={isExpanded ? (primaryColor as any) : defaultColor}
	/>
);
